import gql from 'graphql-tag';

export const GET_SESSION_INFO = gql`
  query {
    session {
      sessionId
      user {
        orgId
        userId
        profile {
          phoneNumber
          firstName
          lastName
          middleName
          dateOfBirth
          email
          avatar
          timezone
          policyId
          externalId
          isVerified
          isIdEligible
          title
          gender
          changePasswordRequired
          description
          address
        }

        dynamicPermissions {
          orgNodeId
          roleResources {
            resourceCode
            create
            read
            update
            delete
            assign
            children {
              resourceCode
              create
              read
              update
              delete
              assign
            }
          }
        }
      }

      permissions {
        orgNodeId
        roleResources {
          resourceCode
          create
          read
          update
          delete
          assign
        }
      }

      activeConversations {
        appointmentId
        conversationId
      }
    }
  }
`;

export const GET_ACTIVE_CONVERSATIONS = gql`
  query {
    session {
      activeConversations {
        appointmentId
        conversationId
      }
    }
  }
`;

